import type { ReactNode } from 'react';

export type PageProps = {
  title: ReactNode;
  subtitle?: ReactNode;
  actions?: ReactNode;
  badges?: ReactNode;
  children?: ReactNode;
  fluid?: boolean;
};

export function Page({ title, subtitle, actions, badges, children, fluid }: PageProps) {
  return (
    <div className={fluid ? 'page-fluid' : 'page'}>
      <div className="page-header">
        <div className="page-header-title">
          <h1>
            {title}
            {badges}
          </h1>
          {subtitle ? <span className="page-header-subtitle">{subtitle}</span> : null}
        </div>
        {actions ? <div className="page-header-actions">{actions}</div> : null}
      </div>
      {children}
    </div>
  );
}

export function EmptyState({
  icon,
  title,
  description,
  action,
}: {
  icon?: ReactNode;
  title: ReactNode;
  description?: ReactNode;
  action?: ReactNode;
}) {
  return (
    <div className="ui-empty">
      {icon ? <div className="ui-empty-icon">{icon}</div> : null}
      <div className="ui-empty-title">{title}</div>
      {description ? <div className="ui-empty-desc">{description}</div> : null}
      {action}
    </div>
  );
}
